export enum LicenceType {
  ScandataOnly = 'ScandataOnly',
  ScandataWithLoyalty = 'ScandataWithLoyalty',
  StoreOpsWithScandata = 'StoreOpsWithScandata',
  StoreOpsWithLoyalty = 'StoreOpsWithLoyalty',
}
